import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CoreModule } from '@core/core.module';
import { HelpersModule } from '@core/components/helpers/helpers.module';

import { AppRouterModule } from '@app/router.module';
import { SettingsRulesRulesFormHelpersSearchModule } from './search/rules-form-helpers-search.module';

import { SettingsRulesFormHelperSelectComponent } from './helper-select/helper-select.component';
import { SettingsRulesFormHelperSelectMultipleComponent } from './helper-select-multiple/helper-select-multiple.component';


@NgModule({
    imports: [
        CommonModule,
        AppRouterModule,
        FormsModule,
        ReactiveFormsModule,
        CoreModule,
        HelpersModule,
        SettingsRulesRulesFormHelpersSearchModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        SettingsRulesFormHelperSelectComponent,
        SettingsRulesFormHelperSelectMultipleComponent,
    ],
    exports: [
        SettingsRulesFormHelperSelectComponent,
        SettingsRulesFormHelperSelectMultipleComponent,
        SettingsRulesRulesFormHelpersSearchModule, //modules inside should be exported as well 
    ],

})
export class SettingsRulesRulesFormHelpersModule { }
